import { useNavigate } from "react-router-dom";
import { useContext } from "react";

import { AuthContext } from "./AuthContext";
import { firebaseAuth } from "../utils/firebaseAuth";

const useLogout = () => {
  const navigate = useNavigate();
  const { logoutAuth } = useContext(AuthContext);

  const logout = async () => {
    const confirmLogout = window.confirm("Are you sure you want to log out?");
    if (confirmLogout) {
      logoutAuth();

      if (firebaseAuth?.currentUser) {
        try {
          await firebaseAuth.signOut();
        } catch (error) {
          console.error("Firebase sign-out failed:", error);
        }
      }

      navigate("/login");
      window.location.reload();
    }
  };

  return logout;
};

export default useLogout;
